import axios from 'axios';
import authHeader from '/src/services/auth.header';
const API_URL = process.env.VUE_APP_API_URL

class UserService {
    login(username, password) {
        return axios
            .post(API_URL + 'login/', {
                username: username,
                password: password
            })
    }

    self() {
        return axios.get(`${API_URL}user/self/`, {headers: authHeader()})
    }

    logout() {
        console.log('prima chiamata')
        return axios.post(`${API_URL}logout/`, {headers: authHeader()})
    }

    list(params) {
        return axios.get(`${API_URL}user/`, {
            headers: authHeader(),
            params: params
        })
    }

    resetPassword(email) {
        return axios.post(`${API_URL}reset-password/`, {
            email: email
        })
    }

    updateUISettings(settings) {
        return axios.patch(`${API_URL}user/self/ui_settings/`, settings, {
            headers: authHeader()
        })
    }

    // Metodi per gestione permessi ruoli
    getRolePermissions() {
        return axios.get(`${API_URL}role-permissions/get_role_permissions/`, {
            headers: authHeader()
        })
    }

    updateRolePermissions(rolePermissions) {
        return axios.post(`${API_URL}role-permissions/update_role_permissions/`, {
            role_permissions: rolePermissions
        }, {
            headers: authHeader()
        })
    }

    resetRolePermissions() {
        return axios.post(`${API_URL}role-permissions/reset_role_permissions/`, {}, {
            headers: authHeader()
        })
    }

    getPermissionSchema() {
        return axios.get(`${API_URL}role-permissions/get_permission_schema/`, {
            headers: authHeader()
        })
    }
}

export default new UserService();
